export class AutoCapturaServiceErros {
  static mapErros(response) {
    if (!response.data.erro)
      return 'Infelizmente não foi possível adicionar os dados. Verifique os campos informados.';

    if (
      response.data.erro &&
      response.data.erro.indexOf('ExceptionMessage') !== -1
    )
      return response.data.message;

    switch (response.data.erro) {
      case 'PortadorNaoEncontradoException':
        return 'Portador informado não encontrado.';
      case 'CidadeVaziaException':
        return 'Dado de cidade veio vazio.';
      case 'NacionalidadeVaziaException':
        return 'Dado nacionalidade veio vazio.';
      case 'NomeVazioException':
        return 'Dado nome veio vazio.';
      case 'SexoInvalidoException':
        return 'O dado do campo sexo está inválido.';
      case 'EstadoCivilVazioException':
        return 'O estado civil está incorreto.';
      case 'NomeDaMaeVazioException':
        return 'Nome da mãe está vazio.';
      case 'NascimentoInvalidaException':
        return 'Data de nascimento está inválida.';
      case 'NascimentoComMaisDe100AnosException':
        return 'Não é permitido ter mais de 100 anos.';
      case 'NascimentoComMenosDe18AnosException':
        return 'Não é permitido ter menos de 18 anos.';
      case 'CelularVazioException':
        return 'Celular está vazio.';
      case 'CelularInvalidoException':
        return 'Celular está incorreto.';
      case 'EmailVazioException':
        return 'E-mail está vazio.';
      case 'EmailInvalidoException':
        return 'E-mail está incorreto.';
      case 'TamanhoDosCamposInvalidosException':
        return 'O tamanho do texto está incorreto.';
      case 'CepInvalidoException':
        return 'O cep informado está inválido.';
      case 'LogradouroVazioException':
        return 'O logradouro está vazio.';
      case 'NumeroInvalidoException':
        return 'O número está vazio.';
      case 'NumeroEComplementoVazioException':
        return 'O número ou o complemente devem estar preenchidos.';
      case 'BairroVazioException':
        return 'O bairro está vazio.';
      case 'CidadeVazioException':
        return 'A cidade está vazia.';
      case 'UfVazioException':
        return 'O uf veio vazio.';
      case 'NumeroVazioException':
        return 'Número está vazio.';
      case 'EmissaoVaziaException':
        return 'Data de emissão está vazio.';
      case 'EmissaoSuperiorADataAtualException':
        return 'Data de emissão maior que a data atual.';
      case 'EmissaoInferiorADataMinimaException':
        return 'A data de emissão não pode ser inferior a 31/12/1900.';
      case 'OrgaoExpedidorVazioException':
        return 'Orgão expedidor está vazio.';
      case 'UfInvalidoException':
        return 'Uf está incorreto.';
      case 'RendaMensaInvalidaException':
        return 'Renda mensal está inválida.';
      case 'CpfInvalidoException':
        return 'Cpf informado está incorreto.';
      case 'TipoVazioException':
        return 'Tipo está vazio.';
      case 'EmpresaVaziaException':
        return 'Empresa está vazio.';
      case 'AdmissaoInvalidaException':
        return 'Admissão está inválido.';
      case 'RedeNaoEncontradaException':
        return 'Rede não cadastrada.';
      case 'TemplateNaoEncontradoException':
        return 'Template da proposta não encontrado no repositorio.';
      case 'PdfNaoEncontradoException':
        return 'PDF não encontrado.';
      case 'ConviteExpiradoException ':
        return 'Convite expirou a data de validade.';
      case 'ConviteInvalidoException':
        return 'Digitação incorreta. Tente novamente.';
      case 'ConviteInvalidoExpiradoException':
        return 'Convite inválido ou expirado.';
      case 'ImagemDeBaixaQualidadeException':
        return 'A imagem está com baixa qualidade. Tente novamente.';
      case 'NenhumaFaceDetectadaException':
        return 'Não foi encontrao nenhuma face na foto.';
      case 'MaisDeUmaFaceDetectadaException':
        return 'Foi reconhecido mais um rosto na foto. Tente novamente.';
      case 'ArquivoInvalidoException':
        return 'A foto veio em um arquivo inválido.';
      case 'DadosEObrigatorioException':
        return 'É necessário aceitar todos os termos de uso.';
      case 'EmbossingVazioException':
        return 'Preencha o nome impresso do cartão.';
      case 'DiaDeVencimentoInvalidoException':
        return 'Dia de vencimento inválido.';
      case 'ExcedeuQuantidadeDeTentativasPossiveisException':
        return 'Atingiu o limite máximo tentativas. Por favor, tente novamente mais tarde.';
      case 'EnderecoNaoEncontradoException':
        return 'O CEP informado não foi localizado ou está incorreto.';
      case 'RendaMensalInferiorAoSalarioMinimoException':
        return 'O valor da renda não pode ser menor que 1 salário mínimo.';
      case 'RendaMensalInvalidaException':
        return 'O valor da renda não pode ser menor que 1 salário mínimo.';
      case 'ConviteNaoEncontradoException':
        return 'O convite não foi encontrado.';
      case 'DataDeNascimentoEhObrigatorioException':
        return 'A data de nascimento é obrigatória.';
      case 'CpfRejeitadoPreAvaliacaoException':
        return '<i>Agradecemos seu interesse pelo cartão, mas nesse momento não foi possível atendê-lo.</i> <br />';
      case 'BiometriaAdicionarErroException':
        return 'Ocorreu um erro ao validar a sua foto. Pedimos por gentileza que se dirija a uma loja parceira Credz.';
      case 'LojaNaoEncontradaException':
        return 'A loja informada não foi encontrada.';
      case 'TamanhoEmbossingInvalidoException':
        return 'Reduzir o texto do campo Nome do Cartão.';
      case 'ParametroSistemaNaoEncontradoException':
        return 'Parâmetro de sistema não encontrado.';
      default:
        return 'Não foi possível realizar a solicitação no momento.';
    }
  }

  static mapErrosResponse(response) {
    return this.mapErros(response);
  }
}
